import { userInfoApi } from './userInfo.js'

export const userListServe = {
  ...userInfoApi,
}
